<template>
  <check-base-layout :pagetitle="pagetitle" :check-info-data="checkFrom">
    <template>
      <div>
        <supplier-module :supplier-data="checkFrom.supplierAccountContentVo"></supplier-module>
      </div>
      <check-module :title="`充值类型`">
        <el-row v-if="checkFrom.supplierAccountContentVo">
          <el-col :span="8">
            <div>充值至账户余额：{{checkFrom.amount}}</div>
          </el-col>
          <el-col :span="8">
            <div>充值至抵扣金额：{{checkFrom.deductionAmount}}</div>
          </el-col>
        </el-row>
      </check-module>
      <check-module :title="`账户信息`">
        <template>
          <el-row>
            <el-col :span="8">
              <div class="pb20">账户名称：{{checkFrom.receiptName}}</div>
            </el-col>
            <el-col :span="8">
              <div>开户行：{{checkFrom.receiptOpenBank}}</div>
            </el-col>
            <el-col :span="8">
              <div>银行账号：{{checkFrom.receiptBankNumber}}</div>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">
              <div>银行行号：{{checkFrom.receiptOpenNumber}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
      <check-module :title="`充值信息`">
        <template>
          <!--          <el-row>-->
          <!--            <el-col :span="8">-->
          <!--              <div>申请充值金额：{{(checkFrom.payAmount || 0)}}</div>-->
          <!--            </el-col>-->
          <!--          </el-row>-->
          <!--          <el-divider></el-divider>-->
          <el-row>
            <el-col :span="8">
              <div>充值方式：{{payMethodState[checkFrom.payMethod]}}</div>
            </el-col>
            <el-col :span="8">
              <div>申请充值金额：{{checkFrom.payAmount || 0}}</div>
            </el-col>
          </el-row>
        </template>
      </check-module>
    </template>
    <template #checkFooter>
      <slot name="footer">
        <check-module :title="`审批信息`">
          <check-info-module :check-data="checkFrom.systemFlowRunAuditOrgVos"></check-info-module>
        </check-module>
      </slot>
    </template>
  </check-base-layout>
</template>

<script>
import poMixins from '@/mixin/poMixins'
import checkApi from '@/api/workbench/check'
import { payMethodState } from '@/meun/date'
export default {
  name: 'supplierrechargeCheck',
  mixins: [poMixins],
  props: {
    pagetitle: {
      type: String,
      default: '供货商充值审批'
    }
  },
  data () {
    return {
      payMethodState
    }
  },
  created () {
    this.getSupplierrechargeInfo()
  },
  methods: {
    getSupplierrechargeInfo () {
      const {
        snaId
      } = this
      checkApi.getSupplierrechargeCheckInfo({
        snaId
      }).then(res => {
        if (this.isSuccess(res)) {
          this.checkFrom = this.formatterSupplierInfo(res.data.obj)
          this.$emit('update:data', this.checkFrom)
        }
      })
    }
  }
}
</script>

<style scoped lang="less">
  /deep/.el-divider--horizontal {
    margin: 15px 0;
  }
</style>
